import React, {useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import SignatureCanvas from "react-signature-canvas";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {errorBox_Show, setSignaturePopupState} from "../../../actions/A_Popups";


const SignaturePadPopup = (props) => {

  const {setSignaturePopupState, signatureImage, onSignCallBack, errorBox_Show} = props;

  const sigCanvas = useRef(null);

  const setCanvasImage = () => {
    if (!signatureImage) {
      return
    }
    // here we are not using native .fromDataURL() method, because it is resizing the image, if we want to use fromDataURL
    // then we need instead of .getTrimmedCanvas().toDataURL('image/png') use .toDataURL(), but it enlarges the image
    // sigCanvas.current._sigPad._reset();
    const copy = document.createElement('canvas');
    copy.width = sigCanvas.current._canvas.width
    copy.height = sigCanvas.current._canvas.height;
    const image = new Image();
    image.src = signatureImage;
    image.onload = () => {
      copy.getContext('2d').drawImage(image,
        copy.width / 2 - image.width / 2,
        copy.height / 2 - image.height / 2
      );
      sigCanvas.current.fromDataURL(copy.toDataURL('image/png'));
      sigCanvas.current._sigPad._isEmpty = false;
    };
  }

  useEffect(() => {
    setCanvasImage()
  }, []);

  const closePopup = () => {
    setSignaturePopupState({opened: false, signatureImage: "", onSignCallBack: null}); // clear values
  }

  const applySignature = () => {
    if (sigCanvas.current.isEmpty()) {
      errorBox_Show({text: 'Signature is required.'})
      return
    }
    const pngBase64 = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');

    closePopup(pngBase64);
    onSignCallBack(pngBase64);
  }

  return (
    <div className="ui-popup ui-popup--common flex flex--column" style={{maxHeight: "420px"}}>
      <button className="ui-popup-header__close" onClick={closePopup}/>
      <div className="ui-popup__header">
          <span className="ui-popup__header-title">
            <FormattedMessage id="contractSign.requiredFieldsNoticeText"/>
          </span>
      </div>
      <div className="flex-item pl-2 pr-2 pt-1 border-box">
        <SignatureCanvas canvasProps={{className: 'w-full contract-popup__canvas'}}
                         ref={sigCanvas}/>
      </div>
      <div className="ui-popup-footer">
        <button className="ui-button5 text-uppercase ui-button5--blue"
                onClick={() => sigCanvas.current.clear()}>
          <FormattedMessage id="contractSign.footerClearButton"/>
        </button>
        <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--green"
                onClick={applySignature}>
          <FormattedMessage id="contractSign.sign"/>
        </button>
      </div>
    </div>
  )
}

SignaturePadPopup.propTypes = {
  signature: PropTypes.string,
  onSignCallBack: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {signatureImage, onSignCallBack} = store.popups.signaturePadPopup;
  return {
    signatureImage,
    onSignCallBack,
  }
};

const mapDispatchToProps = {
  setSignaturePopupState,
  errorBox_Show,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SignaturePadPopup)
)
